import { Flex, Skeleton } from "@fluentui/react-northstar";
import {
    Card,
    HoursText,
    STextRecuperation,
} from "../../../../components/Cards/CardAnnualRecovery/CardAnnualRecovery";

const CardHeaderInformation = ({
    icon,
    title,
    value,
    isLoading = false,
    unit = "h",
}) => {
    return (
        <Card column gap="gap.medium">
            <Flex vAlign="center" gap="gap.smaller" space="between" fill>
                <Flex vAlign="center" gap="gap.smaller">
                    {icon}
                    <STextRecuperation content={title} />
                </Flex>
            </Flex>
            <Flex column vAlign="center" fill>
                <Flex>
                    {isLoading ? (
                        <Skeleton animation="pulse">
                            <Skeleton.Line width="90px" height="26px" />
                        </Skeleton>
                    ) : (
                        <HoursText unit={unit}>{value}</HoursText>
                    )}
                </Flex>
            </Flex>
            <Flex vAlign="center" gap="gap.smaller" fill></Flex>
        </Card>
    );
};

export default CardHeaderInformation;
